import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
root:{
  paddingTop:20,
  paddingBottom:20
}
}));
